import {createFileRoute} from '@tanstack/react-router';
import BookCourtInviteView from '../../marketplace/BookCourtInviteView';

export const Route = createFileRoute('/book-court/invite/$token')({
    component: RouteComponent,
});

function RouteComponent() {
    return <BookCourtInviteView />;
}
